import { InvoicePaymentMethod } from '../../../../../../api/invoice.types';

export const filterAndMapEnabledPaymentMethods = (options: InvoicePaymentMethod[]) => {
  return options.filter((option) => option.enabled).map(({ type }) => type);
};
